package net.frozenbit.games.soundgame.ui

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.SharedTransitionLayout
import androidx.compose.runtime.Composable
import androidx.compose.runtime.State
import androidx.compose.runtime.getValue
import net.frozenbit.games.soundgame.utils.Countdown
import net.frozenbit.games.soundgame.viewmodels.HostViewModel

@Composable
fun HostScreen(
    hostUiState: HostViewModel.HostUiState,
    countdownTickState: State<Countdown.Tick?>,
    onStartGameClick: () -> Unit,
) {
    SharedTransitionLayout {
        AnimatedContent(
            targetState = hostUiState,
            contentKey = { it::class },
            label = "screen_transitions"
        ) { hostUiState ->
            val countdownText by countdownTickState
            when (hostUiState) {
                is HostViewModel.HostUiState.Idle -> {
                    HostPreGameScreen(
                        loading = hostUiState.loading,
                        onStartGameClick = onStartGameClick,
                    )
                }

                is HostViewModel.HostUiState.Lobby -> {
                    HostLobbyScreen(
                        joinCode = hostUiState.joinCode,
                        players = hostUiState.players,
                        link = hostUiState.joinLink,
                    )
                }

                is HostViewModel.HostUiState.PromptSelection -> {
                    HostPromptSelectionScreen(
                        screenTransitions = this@AnimatedContent,
                        who = hostUiState.selectingPlayer,
                        joinCode = hostUiState.joinCode,
                        countdownText = countdownText,
                    )
                }

                is HostViewModel.HostUiState.SoundSelection -> {
                    HostSoundSelectionScreen(
                        who = hostUiState.jury,
                        joinCode = hostUiState.joinCode,
                        countdownText = countdownText,
                        participants = hostUiState.participants,
                        promptText = hostUiState.promptText,
                    )
                }

                is HostViewModel.HostUiState.Voting -> {
                    HostVotingScreen(
                        joinCode = hostUiState.joinCode,
                        jury = hostUiState.jury,
                        creations = hostUiState.voteOptions,
                        countdown = countdownText,
                        promptText = hostUiState.promptText,
                    )
                }

                is HostViewModel.HostUiState.WinnerPresentation -> {
                    HostWinnerPresentationScreen(
                        joinCode = hostUiState.joinCode,
                        jury = hostUiState.jury,
                        entries = hostUiState.entries,
                        promptText = hostUiState.promptText,
                    )
                }

                is HostViewModel.HostUiState.GameOver -> {
                    HostGameOverScreen(
                        scorings = hostUiState.scorings,
                        credits = hostUiState.credits,
                    )
                }
            }
        }
    }
}

